var createReactClass = require('create-react-class');
import React from 'react';
import AttachmentInsertMixin from './AttachmentInsertMixin';
import Modal from '../Modal';
import Errors from './Errors';
import Details from './Details';

const Video = createReactClass({
  mixins: [AttachmentInsertMixin],
  getInitialState: function(){
    return {
      disableButton: true,
      reupload: false,
      attachment: this.props.attachment
    }
  },

  componentDidMount: function(){
    var self = this;
    self.setState({attachment: self.props.attachment}, function() {
      self.generateIframe()
    })
    $('#add-figure').on("insertItem", ".primary", function(e){ 
      var elem = CKEDITOR.dom.element.createFromHtml(self.state.attachment.html + "\n")
      try{
        self.setCursorPosition();
        self.removeAttachmentForReinsertion(self.state.attachment.type);
        self.ckeditor().insertElement(elem);
      } catch(e) {
        self.moveCursorToStart();
        self.ckeditor().insertElement(elem);
        self.resetCursorPosition();
      }
      self.ckeditor().updateElement();
      self.disableAttachments();
      Modal.close()
    });
  },

  handleReupload: function() {
    this.setState({reupload: true, disableButton: true, video: null, videoError: null})
  },

  generateIframe: function() {
    var self = this;
    var url = $("#attachment_url").val() || self.state.attachment.url
    var src;
    var error;
    if (url) {
      if (url.includes('youtu')) {
        src = "//www.youtube.com/embed/" + self.grabYoutubeVideoId(url);
      } else if (url.includes('vimeo')) {
        src = "https://player.vimeo.com/video/" + self.grabVimeoVideoId(url);
      } else {
        error = "Please enter a valid YouTube or Vimeo URL."
        src = null
      }
      var newAttachment = Object.assign({}, self.state.attachment)
      newAttachment["url"] = url
      self.setState({attachment: newAttachment, video: src, reupload: false, videoError: error}, function() {
        self.isValidNextButton()
      })
    }
  },

  grabYoutubeVideoId: function(url) {
    var regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
    var match = url.match(regExp);

    if (match && match[2].length == 11) {
        return match[2];
    }
  },

  grabVimeoVideoId: function(url) {
    var match = /vimeo.*\/(\d+)/i.exec(url);
    if ( match ) {
      return match[1];
    }
  },

  handleUpdate: function(e, data){
    var self = this;
    self.props.handleUpdate(e, data, function(serializedAttachmentData) {
      self.setState({
        disableButton: true,
        attachment: serializedAttachmentData
      }, function() {$("#add-figure .primary").trigger("insertItem")})
    });
  },

  handleSubmit: function(e) {
    e.preventDefault()
    var self = this;
    self.setState({disableButton: true})
    var payload = {
      attachment: {
        title: self.state.attachment.title,
        legend: self.state.attachment.legend,
        url: self.state.attachment.url
      }
    }
    self.handleUpdate(e, payload)
  },

  isValidNextButton: function() {
    var validTitle = ($("#attachment_title").val() !== "") && ($("#attachment_title").val() !== undefined);
    var validVideo = this.state.attachment.has_file || this.state.video
    var validCharacterCount = this.state.characterCount <= 2000
    this.setValidState((validTitle && validVideo && validCharacterCount && !this.state.videoError));
  },

  renderErrors: function() {
    if (this.props.errorMessage) {
      return (
        <Errors message={this.props.errorMessage}/>
      )
    }
  },

  renderVideoUploader: function() {
    if ((this.state.attachment.has_file || this.state.video) && this.state.reupload === false && !this.state.videoError) {
      return (
        <div className="media-uploader video">
          <div className="media-preview video" style={{textAlign: 'center'}}>
            <iframe width="400" height="200" src={ this.state.video } frameBorder="0" allowFullScreen></iframe>
            <a className={'button small alert replace-button'} onClick={this.handleReupload}>Replace</a>
          </div>
        </div>
      )
    } else {
      return (
          <div className="media-uploader video">
            <div className="media-preview video">
            <div className="media-preview-content-frame">
              {this.renderErrors()}
              <p>Insert a video from YouTube or Vimeo. To add the video, you'll need to copy and paste its URL.</p>
              <p>Video URL: <span>&nbsp;{this.state.videoError}</span></p>
              <input autoComplete="off" id="attachment_url" name="attachment[url]" type="text" defaultValue={ this.state.attachment.url } className="left" placeholder="Paste the YouTube or Vimeo link here, e.g. https://www.youtube.com/watch?..." />
              <a className="button primary pull-right" onClick={ this.generateIframe }>Search</a>
            </div>
          </div>
        </div>
      )
    }
  },

  renderInsertButton: function() {
    var emptyTitle = ($("#attachment_title").val() === "") || ($("#attachment_title").val() === undefined)
    if (this.state.disableButton && emptyTitle) {
      return (
        <span className="tip-top" data-tooltip={this.state.disableButton} id="next-button" title="Please enter a title to proceed. (Scroll down).">
          <a className={'button primary ' + this.disableButtonClass()} data-tooltip={this.state.disableButton} onClick= {this.handleSubmit}>Insert</a>
        </span>
      )
    } else {
      return (
        <a className={'button primary ' + this.disableButtonClass()} onClick={this.handleSubmit}>Insert</a>
      )
    }
  },

  render: function() {
    return (
      <div className="reveal-modal custom-full attachment-modal" data-reveal>
        <div className='modal-content' id='add-figure'>
          <div className='modal-header'>
            <h4 className="reg">Insert Video</h4>
            <div className='modal-close'>
              <a className="cancel-modal">
                <img alt="Close_x" src="https://public.cureus.com/close_x.png"/>
              </a>
            </div>
            <p className="title"> Please review our <a target="_blank" href={this.props.mediaGuidePath + '#video-add'}>Video Guidelines</a> for detailed instructions for inserting videos.</p>
          </div>
          <div className='modal-body video'>
            {this.renderVideoUploader()}
            <Details
              isValidNextButton={this.isValidNextButton}
              attachment={this.state.attachment}
              handleCharacterCount={this.handleCharacterCount}
              setValidState={this.setValidState}
              updateKey={this.updateKey}
            />
          </div>
          <div className='modal-footer'>
            <a className='cancel-modal button secondary'>Cancel</a>
            {this.renderInsertButton()}
          </div>
        </div>
      </div>
    ) }
  })
  
  export default Video;
